import { Card, CardContent } from '@/components/ui/card';

interface FundedSummaryCardsProps {
  totalCount: number;
  totalVolume: number;
  avgLoanSize: number;
  avgDaysInWarehouse: number;
  byChannel: Map<string, { count: number; volume: number }>;
  purchasedCount: number;
}

export function FundedSummaryCards({
  totalCount,
  totalVolume,
  avgLoanSize,
  avgDaysInWarehouse,
  byChannel,
  purchasedCount
}: FundedSummaryCardsProps) {
  const formatCurrency = (amount: number) => {
    if (amount >= 1_000_000) {
      return `$${(amount / 1_000_000).toFixed(1)}M`;
    }
    if (amount >= 1_000) {
      return `$${(amount / 1_000).toFixed(0)}K`;
    }
    return `$${amount.toFixed(0)}`;
  };

  const banked = byChannel.get('Banked - Retail') || { count: 0, volume: 0 };
  const brokered = byChannel.get('Brokered') || { count: 0, volume: 0 };

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
      {/* Total Funded */}
      <Card>
        <CardContent className="p-4">
          <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
            Total Funded
          </div>
          <div className="mt-1 text-2xl font-bold">{totalCount}</div>
          <div className="text-sm text-muted-foreground">
            {formatCurrency(totalVolume)}
          </div>
        </CardContent>
      </Card>

      {/* Avg Loan Size */}
      <Card>
        <CardContent className="p-4">
          <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
            Avg Loan Size
          </div>
          <div className="mt-1 text-2xl font-bold">
            {formatCurrency(avgLoanSize)}
          </div>
        </CardContent>
      </Card>

      {/* Avg Warehouse Days */}
      <Card>
        <CardContent className="p-4">
          <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
            Avg Whse Days
          </div>
          <div className="mt-1 text-2xl font-bold">
            {avgDaysInWarehouse > 0 ? Math.round(avgDaysInWarehouse) : '-'}
          </div>
          <div className="text-sm text-muted-foreground">Fund to Purchase</div>
        </CardContent>
      </Card>

      {/* Banked */}
      <Card>
        <CardContent className="p-4">
          <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
            Banked
          </div>
          <div className="mt-1 text-2xl font-bold">{banked.count}</div>
          <div className="text-sm text-muted-foreground">
            {formatCurrency(banked.volume)}
          </div>
        </CardContent>
      </Card>

      {/* Brokered */}
      <Card>
        <CardContent className="p-4">
          <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
            Brokered
          </div>
          <div className="mt-1 text-2xl font-bold">{brokered.count}</div>
          <div className="text-sm text-muted-foreground">
            {formatCurrency(brokered.volume)}
          </div>
        </CardContent>
      </Card>

      {/* Purchased */}
      <Card>
        <CardContent className="p-4">
          <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
            Purchased
          </div>
          <div className="mt-1 text-2xl font-bold">{purchasedCount}</div>
          <div className="text-sm text-muted-foreground">
            of {totalCount}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
